/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/9/14
 * Time: 7:37 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var template = require("connection-templates/mainContainerLayout.tmpl");
    var CP_CONST = require("connection-const");

    var MainContainerLayout = {};
    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {
        MainContainerLayout = Marionette.Layout.extend({
            //className: "connection-panel-main-container close",
            className: "connection-panel-main-container cp-shadow",
            template: template,
            regions: {
                ticketRegion: ".ticket-tab-region",
                profileRegion: ".profile-region",
                tabsRegion: ".tabs-region",
                notificationRegion: ".notification-tab-region",
                chatRegion: ".chat-tab-region",
                KPsRegion: ".KPs-tab-region"
            },
            ui: {
                ticketWrapper: ".ticket-tab-wrapper",
                ticketRegion: ".ticket-tab-region",
                notificationRegion: ".notification-tab-region",
                chatRegion: ".chat-tab-region",
                KPsRegion: ".KPs-tab-region",
                chatWrapper: ".chat-tab-wrapper",
                notificationWrapper: ".notification-tab-wrapper",
                kpsWrapper: ".KPs-tab-wrapper"
            },

            modelEvents: {
                "change:selectedTab":"_displayTab"
            },

            initialize: function (options) {

//
//                var mainContainerStatus = this.model.get("isOpen");
//                if (mainContainerStatus) {
//                    this._openMainContainer();
//                }
            },
            onRender: function () {
                var that = this;
                this.isRendered = true;
                var selectedTab = this.model.get("selectedTab");
                this._displayTab(this.model,selectedTab);
                this.ui.kpsWrapper.bind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd",
                   function(){
                       that._hideRegion();
                   });
            },
            _displayTab:function(model,selectedTab){
                switch (selectedTab){
                    default:
                    case(CP_CONST.TABS.CONTENT):
                        this.ui.KPsRegion.removeClass("hide");
                        this.ui.ticketWrapper.addClass("switch-right").removeClass("switch-left");
                        this.ui.chatWrapper.addClass("switch-right").removeClass("switch-left");
                        this.ui.notificationWrapper.addClass("switch-right").removeClass("switch-left");
                        this.ui.kpsWrapper.removeClass("switch-left").removeClass("switch-right");
                        break;
                    case(CP_CONST.TABS.CHAT):
                        this.ui.chatRegion.removeClass("hide");
                        this.ui.kpsWrapper.addClass("switch-left").removeClass("switch-right");
                        this.ui.ticketWrapper.addClass("switch-right").removeClass("switch-left");
                        this.ui.notificationWrapper.addClass("switch-right").removeClass("switch-left");
                        this.ui.chatWrapper.removeClass("switch-left").removeClass("switch-right");
                        break;
                    case(CP_CONST.TABS.TICKET):
                        this.ui.ticketRegion.removeClass("hide");
                        this.ui.chatWrapper.addClass("switch-left").removeClass("switch-right");
                        this.ui.kpsWrapper.addClass("switch-left").removeClass("switch-right");
                        this.ui.notificationWrapper.addClass("switch-right").removeClass("switch-left");
                        this.ui.ticketWrapper.removeClass("switch-left").removeClass("switch-right");
                        break;
                    case(CP_CONST.TABS.NOTIFICATION):
                        this.ui.notificationRegion.removeClass("hide");
                        this.ui.chatWrapper.addClass("switch-left").removeClass("switch-right");
                        this.ui.kpsWrapper.addClass("switch-left").removeClass("switch-right");
                        this.ui.ticketWrapper.addClass("switch-left").removeClass("switch-right");
                        this.ui.notificationWrapper.removeClass("switch-left").removeClass("switch-right");
                        break;
                }
            },

            _hideRegion: function() {
                var tab = this.model.get("selectedTab");
                switch (tab) {
                    case (CP_CONST.TABS.CONTENT):
                        this.ui.chatRegion.addClass("hide");
                        this.ui.ticketRegion.addClass("hide");
                        this.ui.notificationRegion.addClass("hide");
                        break;
                    case(CP_CONST.TABS.CHAT):
                        this.ui.KPsRegion.addClass("hide");
                        this.ui.ticketRegion.addClass("hide");
                        this.ui.notificationRegion.addClass("hide");
                        break;
                    case(CP_CONST.TABS.TICKET):
                        this.ui.KPsRegion.addClass("hide");
                        this.ui.chatRegion.addClass("hide");
                        this.ui.notificationRegion.addClass("hide");
                        break;
                    case(CP_CONST.TABS.NOTIFICATION):
                        this.ui.KPsRegion.addClass("hide");
                        this.ui.chatRegion.addClass("hide");
                        this.ui.ticketRegion.addClass("hide");
                        break;
                }
            }

        });
    });
    return MainContainerLayout;
});
